/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAbbreviatedTalent } from './AbbreviatedTalent';
import { ApiAbbreviatedArticle } from './AbbreviatedArticle';

export interface ArticleFranchiseRequest {

    id?: string;

    /**
     * Name of the franchise
     */
    name?: string;

    /**
     * Description of the franchise
     */
    description?: string;

    /**
     * Talent involved with the franchise
     */
    hosts?: ApiAbbreviatedTalent;

    /**
     * Image of franchise
     */
    image?: string;

    /**
     * Square logo of franchise
     */
    square_logo?: string;

    twitter_handle?: string;

    facebook_url?: string;

    youtube_url?: string;

    /**
     * Determine if there are articles associated with this Franchise
     */
    article_enabled?: boolean;

    web_stories_order?: number;

    /**
     * Determine if articles should be shown in original reporting
     */
    show_in_original_reporting?: boolean;

    articles?: ApiAbbreviatedArticle[];

}

@Model('ArticleFranchise')
export class ApiArticleFranchise extends BaseModel implements ArticleFranchiseRequest {

    
    
    id: string;

    /**
     * Name of the franchise
     */
    
    
    name: string;

    /**
     * Description of the franchise
     */
    
    
    description: string;

    /**
     * Talent involved with the franchise
     */
    @Type('ApiAbbreviatedTalent')
    @Expand()
    hosts: ApiAbbreviatedTalent;

    /**
     * Image of franchise
     */
    
    
    image: string;

    /**
     * Square logo of franchise
     */
    
    
    square_logo: string;

    
    
    twitter_handle: string;

    
    
    facebook_url: string;

    
    
    youtube_url: string;

    /**
     * Determine if there are articles associated with this Franchise
     */
    
    
    article_enabled: boolean;

    
    
    web_stories_order: number;

    /**
     * Determine if articles should be shown in original reporting
     */
    
    
    show_in_original_reporting: boolean;

    @Type('ApiAbbreviatedArticle')
    @Expand()
    articles: ApiAbbreviatedArticle[];

}
